﻿(function() {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  function initReveal() {
    document.querySelectorAll('.shopify-section').forEach(function(section) {
      if (section.closest('.shopify-section-group-footer-group') ||
          section.closest('.shopify-section-group-header-group')) return;
      section.classList.add('humle-reveal');
      observer.observe(section);
    });
  }

  function initSmartHeader() {
    // Target the outer sticky group — changing its `top` collapses the
    // sticky element without leaving a blank gap in the layout.
    var stickyGroup = document.querySelector('.shopify-section-group-header-group');
    var sectionHeader = document.querySelector('#shopify-section-header');
    var header = document.querySelector('.header-wrapper');
    if (!stickyGroup && !header) return;

    var target = stickyGroup || header;
    var lastScroll = 0;
    var ticking = false;
    var hidden = false;

    // Smooth animation via top (sticky) instead of transform
    target.style.transition = 'top 0.38s cubic-bezier(0.4,0,0.2,1)';

    function setPointerEvents(val) {
      target.style.pointerEvents = val;
      if (sectionHeader) sectionHeader.style.pointerEvents = val;
    }

    function hide() {
      if (hidden) return;
      hidden = true;
      target.style.top = '-' + target.offsetHeight + 'px';
      setPointerEvents('none');
      if (header) {
        header.classList.add('header--hidden');
        header.classList.remove('header--scrolled');
        header.style.boxShadow = 'none';
      }
    }

    function show() {
      if (!hidden && target.style.top === '0px') return;
      hidden = false;
      target.style.top = '0px';
      setPointerEvents('');
      if (header) {
        header.classList.remove('header--hidden');
        header.classList.add('header--scrolled');
        header.style.boxShadow = '0 2px 16px rgba(0,0,0,0.1)';
      }
    }

    function reset() {
      hidden = false;
      target.style.top = '0px';
      setPointerEvents('');
      if (header) {
        header.classList.remove('header--hidden', 'header--scrolled');
        header.style.boxShadow = '';
      }
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          var current = window.scrollY;
          var diff = current - lastScroll;

          if (current <= 60) {
            reset();
          } else if (diff > 6) {
            hide();
          } else if (diff < -6) {
            show();
          }

          lastScroll = current;
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  function initReadMore() {
    var desc = document.querySelector('.product__description');
    if (!desc) return;
    function checkAndAdd() {
      if (document.querySelector('.humle-read-more')) return;
      // -webkit-line-clamp causes scrollHeight == clientHeight, so we can't compare them.
      // Instead: temporarily unclamp via inline !important to measure true content height.
      var clampedH = desc.clientHeight;
      if (clampedH === 0) return;
      desc.style.setProperty('-webkit-line-clamp', 'unset', 'important');
      desc.style.setProperty('display', 'block', 'important');
      desc.style.setProperty('overflow', 'visible', 'important');
      var fullH = desc.scrollHeight;
      desc.style.removeProperty('-webkit-line-clamp');
      desc.style.removeProperty('display');
      desc.style.removeProperty('overflow');
      if (fullH <= clampedH + 4) return;
      var btn = document.createElement('button');
      btn.className = 'humle-read-more';
      btn.textContent = 'L\u00e4s mer';
      desc.after(btn);
      btn.addEventListener('click', function() {
        var expanded = desc.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'L\u00e4s mindre' : 'L\u00e4s mer';
      });
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function() { requestAnimationFrame(checkAndAdd); });
    } else {
      setTimeout(checkAndAdd, 500);
    }
  }

  function initPageTransition() {
    document.querySelectorAll('a[href]').forEach(function(link) {
      var href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto') || href.startsWith('tel') || link.target === '_blank') return;
      link.addEventListener('click', function(e) {
        var url = link.href;
        if (url && url.indexOf(window.location.hostname) !== -1) {
          e.preventDefault();
          document.body.classList.add('page-leaving');
          setTimeout(function() { window.location = url; }, 280);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initReveal(); initSmartHeader(); initReadMore(); initPageTransition();
    });
  } else {
    initReveal(); initSmartHeader(); initReadMore(); initPageTransition();
  }
})();
